import React from 'react'
import './projectList.css'
import ProjectCard from '../ProjectCard/ProjectCard';
import myImg from '../../img/shopPreview.png';
import redditImg from '../../img/reddit.png';
import blanchard from '../../img/blanchard.png';
import todo from '../../img/todo.png';
import pairs from '../../img/pairs.png';
import crm from '../../img/crm.png';


function ProjectList() {
   const items = [{ name: 'Магазин одежды (React)', subtitle: 'Функциональность:', desc: 'Отображение по категориям, cохранение в redux, имитация получения товаров с сервера, loader,корзина, отправка заказа: POST запрос с данными из редакса, скролл наверх, слайдер.', img: myImg, link: 'https://shop-2uxfv14hq-ekaterina-create.vercel.app/' },
   { name: 'Лента постов Reddit(React, TS)', subtitle: 'Функциональность:', desc: 'Аутентификация на Reddit, бесконечный скролл, роутинг, страница 404, использование контекста с данными для отображения данных пользователя и аватара, cохранение токена в Redux.', img: redditImg, link: 'https://reddit0analogue.herokuapp.com/posts' },
   { name: 'Аналог CRM (JS)', subtitle: 'Функциональность:', desc: 'Создание,удаление, редактирование, поиск, клиента, backend на node.', img: crm, link: 'https://github.com/ekaterina-create/CRM' },
   { name: 'Landing сайт Галерея (HTML,JS)', subtitle: 'Функциональность:', desc: 'Выпадающее меню, кастомный скролл, табы, модальное окно.', img: blanchard, link: 'https://blanchard.vercel.app/' },
   { name: 'Todo (React)', subtitle: 'Функциональность:', desc: 'Удаление, добавление дел, поиск, фильтр.', img: todo, link: 'https://todos-three.vercel.app/' },
   { name: 'Игра "Пары" (JS)', subtitle: 'Функциональность:', desc: 'Выбор количества карт, таймер, анимация переворота.', img: pairs, link: 'https://game-pairs.vercel.app/' },
   ]
   return (
      <div>
         
         <div className='container projectlist__container'>

            {items.map((item) => {
               return (
                  <ProjectCard item={item} key={Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)} />
               )
            })}

         </div>
      </div>
   )
}

export default ProjectList
